import './PDFViewer.css'

import React, { useEffect, useRef, useState } from 'react'

interface PDFViewerProps {
  src: string
}

export const PDFViewer: React.FC<PDFViewerProps> = ({ src }) => {
  const containerRef = useRef<HTMLDivElement | null>(null)
  const [isResizing, setIsResizing] = useState(false)
  const [mouseDown, setMouseDown] = useState(false)

  useEffect(() => {
    const handleMouseDown = () => {
      setMouseDown(true)
    }

    const handleMouseUp = () => {
      setMouseDown(false)
      if (isResizing) {
        setIsResizing(false)
      }
    }

    const handleResize = () => {
      if (mouseDown) {
        setIsResizing(true)
      }
    }

    window.addEventListener('mousedown', handleMouseDown)
    window.addEventListener('mouseup', handleMouseUp)

    const resizeObserver = new ResizeObserver(handleResize)
    if (containerRef.current) {
      resizeObserver.observe(containerRef.current)
    }

    return () => {
      resizeObserver.disconnect()
      window.removeEventListener('mousedown', handleMouseDown)
      window.removeEventListener('mouseup', handleMouseUp)
    }
  }, [mouseDown, isResizing])

  return (
    <div
      ref={containerRef}
      className={`pdf-viewer ${isResizing ? 'pointer-events-none' : ''}`}
    >
      <embed
        src={src}
        type="application/pdf"
        width="100%"
        height="100%"
        className={isResizing ? 'pointer-events-none' : ''}
      />
    </div>
  )
}
